<p-datepicker [(ngModel)]="selectedTransactionDate" [disabledDays]="[0,6]" [maxDate]="maxTransactionDate"
    [readonlyInput]="true" [required]="true"></p-datepicker>